import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About Chris', href: '#about' },
    { name: 'South Haven Transportation', href: '#services' },
    { name: 'Karaoke Party Van', href: '#about' },
    { name: 'Rider Reviews', href: '#reviews' },
  ];

  return (
    <>
      <motion.div 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="fixed top-4 left-4 right-4 md:top-6 md:left-8 md:right-8 z-50 flex justify-center pointer-events-none"
      >
        <nav className={`pointer-events-auto w-full max-w-6xl transition-all duration-500 rounded-3xl border ${
          isScrolled 
            ? 'bg-black/70 backdrop-blur-xl border-white/10 shadow-[0_12px_40px_rgba(0,0,0,0.4)] py-3 md:py-4 px-6 md:px-10' 
            : 'bg-black/20 backdrop-blur-md border-white/5 py-5 md:py-6 px-6 md:px-10'
        }`}>
          <div className="flex justify-between items-center">
            <a href="#home" className="flex flex-col group">
              <span className="font-serif text-2xl md:text-3xl font-medium tracking-wide text-white leading-none">
                South Haven
              </span>
              <span className="font-sans text-[0.6rem] md:text-[0.65rem] tracking-[0.4em] text-accent uppercase font-bold mt-1.5 group-hover:text-white transition-colors">
                Ride Share
              </span>
            </a>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center space-x-10">
              {navLinks.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href}
                  className="text-[0.65rem] tracking-[0.2em] uppercase font-semibold text-white/80 hover:text-accent transition-colors duration-300"
                >
                  {link.name}
                </a>
              ))}
              <a 
                href="tel:2699106622"
                className="px-8 py-3 bg-accent text-white text-[0.7rem] tracking-[0.2em] uppercase font-bold hover:bg-white hover:text-primary transition-all duration-300 rounded-full shadow-lg"
              >
                Call Chris
              </a>
            </div>

            {/* Mobile Menu Toggle */}
            <button 
              className="lg:hidden text-2xl text-white p-2 focus:outline-none"
              onClick={() => setMobileMenuOpen(true)}
            >
              <SafeIcon icon={FiIcons.FiMenu} />
            </button>
          </div>
        </nav>
      </motion.div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1.1 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="fixed inset-0 z-[60] bg-primary/95 backdrop-blur-2xl flex flex-col items-center justify-center p-6"
          >
            <button 
              className="absolute top-8 right-6 text-3xl text-white/50 hover:text-white p-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon={FiIcons.FiX} />
            </button>
            
            <div className="flex flex-col items-center space-y-10 text-center">
              {navLinks.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="font-serif text-4xl text-white hover:text-accent transition-colors"
                >
                  {link.name}
                </a>
              ))}
              <div className="h-px w-16 bg-white/20"></div>
              <a 
                href="tel:2699106622"
                className="px-10 py-5 bg-accent text-white text-lg tracking-widest uppercase font-bold rounded-full shadow-2xl"
              >
                Call Chris
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;